export interface CustomWindow extends Window {
  webengage?: {
    user: {
      login: (value: string) => void
      logout: () => void
      setAttribute: (
        key: "we_email" | "we_first_name" | "we_last_name",
        value: string | null
      ) => void
    }
    track: (eventName: string, data?: object) => void
    init: (key: string) => void
    debug: (debug: boolean) => void
    options: (key: string, value: any) => void
  }
}

declare let window: CustomWindow

// eslint-disable-next-line prefer-destructuring
export const webengage =
  typeof window !== "undefined" ? window.webengage : undefined
